import { Description } from '@casavo/base-ui'
import { upperFirst } from 'lodash/fp'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { TokenSupport } from '@/design-lib/base-ui/Typography'
import { Poi, PoiType } from '@/types/poi'
import { getPoiCategoryFromType } from '@/utils/points-of-interest'

import { poiCard, poiCardLeft } from './styles.css'

const PoiCard: React.FC<{ poi: Poi }> = ({ poi }) => {
  const { t } = useTranslation()
  const poiCategory = getPoiCategoryFromType(poi.poiType as PoiType)

  return (
    <div className={poiCard}>
      <div
        className={poiCardLeft}
        style={{
          backgroundImage: `url(/lisa/images/poi/${poi.poiType.toLowerCase()}-icon-white.svg`,
        }}
      />
      <div>
        <Description color="greyscale500">
          <TokenSupport
            values={{ distance: poi.distance }}
          >{`listing-detail:${poiCategory}.${poi.poiType}_distance`}</TokenSupport>
        </Description>
        <Description color="greyscale500">
          {poi.name ? upperFirst(poi.name) : upperFirst(t(`listing-detail:${poiCategory}.${poi.poiType}_label`))}
        </Description>
      </div>
    </div>
  )
}

export default PoiCard
